import { render, staticRenderFns } from "./attribute.vue?vue&type=template&id=c6c189aa&scoped=true&"
import script from "./attribute.vue?vue&type=script&lang=js&"
export * from "./attribute.vue?vue&type=script&lang=js&"
import style0 from "./attribute.vue?vue&type=style&index=0&id=c6c189aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c189aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6c189aa')) {
      api.createRecord('c6c189aa', component.options)
    } else {
      api.reload('c6c189aa', component.options)
    }
    module.hot.accept("./attribute.vue?vue&type=template&id=c6c189aa&scoped=true&", function () {
      api.rerender('c6c189aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/appraisalQuestion/attribute.vue"
export default component.exports